import { graphql, useStaticQuery } from 'gatsby'
import { SiteSettingsAndMetadataQuery } from '../../../graphql/gatsby'

export type SiteSettingsAndMetadata = NonNullable<SiteSettingsAndMetadataQuery>
export type UseSiteSettingsAndMetadata = SiteSettingsAndMetadata

export const useSiteSettingsAndMetadata = (): UseSiteSettingsAndMetadata => {
  return useStaticQuery<SiteSettingsAndMetadataQuery>(
    graphql`
      query siteSettingsAndMetadata {
        sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
          title
          lang
          description
          keywords
          ...siteLogo
        }
        site {
          siteMetadata {
            title
            description
            author
            featureFlags {
              allowPatientRegistration
              allowPractitionerRegistration
              allowPrivateLabelRegistration
              allowStudentRegistration
              allowPatientZipCodeRegistration
              allowDispensaryPatientRegistration
              displayPrimaryBrand
              displayPracticeType
            }
            defaultCheckoutRegistrationType
            registrationRedirectUrl
          }
        }
      }
    `
  )
}
